export default {
  // From TakeMeTour CI
  blue: '#1cb6e6',
  orange: '#e86a1a',
  darkBlue: '#3a525e',
  yellow: '#f0bb42',
  green: '#0b6416',
  darkGray: '#4a4a4a',
  darkGray1: '#979797',
  darkGray2: '#9b9b9b',
  lightGray: '#d0d0d0',
  lightGray1: '#d8d8d8',
  lightGray2: '#f2f2f2',
  // Not from CI
  red: '#d0021b',
  white: '#ffffff',
  black: '#000000',
  tagBlue: '#1890ff',
  mainTheme: '#012f63',
  // Font sizing
  fontSize: {
    headline: 28,
    title: 24,
    subheader: 18,
    body: 13,
    menu: 14,
    caption: 12,
    button: 16
  }
};



// WEBPACK FOOTER //
// ./src/utils/theme.js